import React from 'react';
import { FieldSet, ListFieldSection } from '../../../../Layout';
import { Field, TextOutput, TextInput, Checkbox, CheckboxGroup } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import { hasNonEmptyValue, hasValue } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { not } from 'ramda';

let ClassificationSection = ({ createWorksheetSelector }) => {
  const hasOptionalSuffix = useSelector(
    pipe(createWorksheetSelector('Classification.OptionalSuffix'), hasNonEmptyValue)
  );
  const hasBorderlineMaterial = useSelector(
    pipe(createWorksheetSelector('Classification.BorderlineGroupCode'), hasValue)
  );
  const isFineGrained = useSelector(
    pipe(createWorksheetSelector('Preparation.CoarseOrFineGrainedMaterial'), (m) => m === 'Fine-Grained')
  );
  const materialIsNotPeat = useSelector(pipe(createWorksheetSelector('Preparation.MaterialIsPeat'), not));

  return (
    <>
      <ListFieldSection visible={materialIsNotPeat}>
        <Field
          label="Cobbles and Boulders"
          input={<CheckboxGroup />}
          options={[
            {
              label: 'Field sample contained boulders',
              name: 'MaterialClassification.ContainedBoulders',
            },
            {
              label: 'Field sample contained cobbles',
              name: 'MaterialClassification.ContainedCobbles',
            },
          ]}
        />
      </ListFieldSection>

      <ListFieldSection>
        <Field label="Group Code" input={<TextOutput />} name="Classification.GroupCode" />
        <Field label="Group Name" input={<TextOutput />} name="Classification.GroupName" />
        <FieldSet>
          <Field
            label="Optional Suffix"
            input={<TextOutput />}
            name="Classification.OptionalSuffix"
            visible={hasOptionalSuffix}
          />
          <Field
            label="Append optional suffix"
            input={<Checkbox />}
            name="Classification.AppendOptionalSuffix"
            visible={hasOptionalSuffix}
          />
        </FieldSet>
        <FieldSet>
          <Field
            label="Borderline Material"
            input={<TextOutput />}
            name="Classification.BorderlineGroupCode"
            visible={hasBorderlineMaterial}
          />
          <Field
            label="Append borderline group code"
            input={<Checkbox />}
            name="Classification.AppendBorderlineGroupCode"
            visible={hasBorderlineMaterial && !isFineGrained}
          />
        </FieldSet>
        <Field label="Custom prefix" input={<TextInput />} name="Classification.CustomPrefix" maxLength="100" />
        <Field label="Custom suffix" input={<TextInput />} name="Classification.CustomSuffix" maxLength="500" />
      </ListFieldSection>
    </>
  );
};

ClassificationSection = withInjectedProps(ClassificationSection);

export { ClassificationSection };
export default ClassificationSection;
